import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'

import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import pitch from '@assets/images/icon/stadium-icon.svg'
import weather from '@assets/images/icon/Cloud.svg'
import wincup from '@assets/images/icon/wincup.svg'
import avg from '@assets/images/icon/average-icon.svg'

const MyImage = dynamic(() => import('@shared/components/myImage'))

const InfoList = ({ fantasystyles, overViewData, overviewWeather, overviewPitch }) => {
  return (
    <Row className={`${styles.list} row-4 mb-3 mt-3`}>
      <Col sm={6} xl={3} md={6} xs={6} className='mb-2 mb-xl-0'>
        <div className={`${styles.item} h-100 common-box d-md-flex mb-0 align-items-center`}>
          <div className={`${styles.icon} me-3 flex-shrink-0`}>
            <MyImage src={wincup} alt="Prediction" layout="responsive" />
          </div>
          <div className="ms-2 ms-md-0 mt-md-0 mt-2">
            <div className={`${styles.value} fw-bold`}>
              {overViewData?.oWinnerTeam?.sAbbr || overViewData?.oWinnerTeam?.sTitle || '-'}
            </div>
            <p className={`${fantasystyles?.itemSubTitle} ${styles.itemTitle} text-muted mb-0`}>
              <span>Predicted to win</span>
            </p>
          </div>
        </div>
      </Col>
      {/* {overViewData?.sWeatherReport && ( */}
      <Col sm={6} xl={3} md={6} xs={6} className='mb-2 mb-xl-0'>
        <div className={`${styles.item} h-100 common-box d-md-flex mb-0  align-items-center`}>
          <div className={`${styles.icon} me-3 flex-shrink-0`}>
            <MyImage src={weather} alt="weather" layout="responsive" />
          </div>
          <div className="ms-2 ms-md-0 mt-md-0 mt-2">
            <div className={`${styles.value} fw-bold`}>{overViewData?.sWeatherReport ? overViewData?.sWeatherReport : '-'}</div>
            <p className={`${fantasystyles?.itemSubTitle} ${styles.itemTitle} text-muted mb-0`}>
              <span>{'Weather Report'}</span>
            </p>
          </div>
        </div>
      </Col>
      {/* )} */}
      {/* {overViewData?.sPitchCondition && ( */}
      <Col sm={6} xl={3} md={6} xs={6} className='mb-2 mb-xl-0'>
        <div id="pitch" className={`${styles.item} h-100 common-box d-md-flex mb-0 align-items-center`}>
          <div className={`${styles.icon} me-3 flex-shrink-0`}>
            <MyImage src={pitch} alt="pitch" layout="responsive" />
          </div>
          <div className="ms-2 ms-md-0 mt-md-0 mt-2">
            <div className={`${styles.value} fw-bold`}>{overViewData?.sPitchCondition ? overViewData?.sPitchCondition : '-'}</div>
            <p className={`${fantasystyles?.itemSubTitle} ${styles.itemTitle} text-muted mb-0`}>
              <span>{'Pitch Condition'}</span>
            </p>
          </div>
        </div>
      </Col>
      {/* )} */}
      {/* {overViewData?.sAvgScore && ( */}
      <Col sm={6} xl={3} md={6} xs={6} className='mb-2 mb-xl-0'>
        <div className={`${styles.item} h-100 common-box d-md-flex mb-0 align-items-center`}>
          <div className={`${styles.icon} me-3 flex-shrink-0`}>
            <MyImage src={avg} alt="Score" layout="responsive" />
          </div>
          <div className="ms-2 ms-md-0 mt-md-0 mt-2">
            <div className={`${styles.value} fw-bold`}>{overViewData?.sAvgScore ? overViewData?.sAvgScore : '-'}</div>
            <p className={`${fantasystyles?.itemSubTitle} text-muted mb-0`}>
              {/* <span>{"Avg 1st Inn Score"}</span> */}
              <span>Avg. 1st inning score</span>
            </p>
          </div>
        </div>
      </Col>
      {/* )} */}
    </Row>
  )
}

InfoList.propTypes = {
  fantasystyles: PropTypes.any,
  overViewData: PropTypes.object,
  overviewWeather: PropTypes.object,
  overviewPitch: PropTypes.object
}

export default InfoList
